module.exports = __webpack_public_path__ + "img/icon-target-active.3316fb2c.svg";